import { LazyLoad } from 'app/utils';

export const InfoFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.InfoFormPage,
);
